import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Gestión
import Opciones from "@/views/Gestion/Opciones/Opciones.vue";
import Ciudades from "@/views/Gestion/Ciudades/Ciudades.vue";
import Terminales from "@/views/Gestion/Terminales/Terminales.vue";
import Dispositivos from "@/views/Gestion/Dispositivos/Dispositivos.vue";
import Agencias from "@/views/Gestion/Agencias/Agencias.vue";
import Roles from "@/views/Gestion/Roles/Roles.vue";
import Usuarios from "@/views/Gestion/Usuarios/Usuarios.vue";
import Layouts from "@/views/Gestion/LayoutsAutobus/LayoutsAutobus.vue";
import Unidades from "@/views/Gestion/Unidades/Unidades.vue";
import Operadores from "@/views/Gestion/Operadores/Operadores.vue";
import Tramos from "@/views/Gestion/Tramos/Tramos.vue";
import Rutas from "@/views/Gestion/Rutas/Rutas.vue";
import Precios from "@/views/Gestion/Precios/Precios.vue";
import Descuentos from "@/views/Gestion/Descuentos/Descuentos.vue";
import Corridas from "@/views/Gestion/Corridas/Corridas.vue";
import CanjeMasivo from "@/views/Gestion/Corridas/CanjeMasivo.vue";
import UserProfile from "@/views/Gestion/UserProfile/UserProfile.vue";
import Venta from "@/views/Operacion/Venta/Venta.vue";
import Boletos from "@/views/Operacion/Boletos/Boletos.vue";
import Arqueo from "@/views/Operacion/Arqueo/Arqueo.vue";
import MovimientoCaja from "@/views/Operacion/MovimientoCaja/MovimientoCaja.vue";
import CheckLuggage from "@/views/Operacion/CheckLuggage/CheckLuggage.vue";
import Boarding from "@/views/Operacion/Boarding/Boarding.vue";
import Facturacion from "@/views/Operacion/Facturacion/Facturacion.vue";
import FacturacionGlobal from "@/views/Operacion/Facturacion/FacturacionGlobal.vue";
import Autorizaciones from "@/views/Gestion/Autorizaciones/Autorizaciones.vue";
import ReporteBoletos from "@/views/Operacion/Reports/ReporteBoletos.vue";
import ReporteSalidas from "@/views/Operacion/Reports/ReporteSalidas.vue";

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );

// Pages
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const PasswordReset = () =>
  import(/* webpackChunkName: "password" */ "@/views/Password/Reset.vue");
const PasswordEmail = () =>
  import(/* webpackChunkName: "password" */ "@/views/Password/Email.vue");

//import middleware
import auth from "@/middleware/auth";
import permissions from "@/middleware/permissions";
import guest from "@/middleware/guest";

let gestionMenu = {
  path: "/gestion",
  component: DashboardLayout,
  name: "Gestion",
  children: [
    {
      path: "opciones",
      name: "Opciones",
      components: { default: Opciones },
      meta: { middleware: permissions }
    },
    {
      path: "autorizaciones",
      name: "Autorizaciones",
      components: { default: Autorizaciones },
      meta: { middleware: permissions }
    },
    {
      path: "ciudades",
      name: "Ciudades",
      component: Ciudades,
      meta: { middleware: permissions }
    },
    {
      path: "terminales",
      name: "Terminales",
      component: Terminales,
      meta: { middleware: permissions }
    },
    {
      path: "dispositivos",
      name: "Dispositivos",
      component: Dispositivos,
      meta: { middleware: permissions }
    },
    {
      path: "agencias",
      name: "Agencias",
      component: Agencias,
      meta: { middleware: permissions }
    },
    {
      path: "roles",
      name: "Roles",
      component: Roles,
      meta: { middleware: permissions }
    },
    {
      path: "users",
      name: "Usuarios",
      component: Usuarios,
      meta: { middleware: permissions }
    },
    {
      path: "layouts",
      name: "Layouts",
      component: Layouts,
      meta: { middleware: permissions }
    },
    {
      path: "unidades",
      name: "Unidades",
      component: Unidades,
      meta: { middleware: permissions }
    },
    {
      path: "operadores",
      name: "Operadores",
      component: Operadores,
      meta: { middleware: permissions }
    },
    {
      path: "tramos",
      name: "Tramos",
      component: Tramos,
      meta: { middleware: permissions }
    },
    {
      path: "rutas",
      name: "Rutas",
      component: Rutas,
      meta: { middleware: permissions }
    },
    {
      path: "precios",
      name: "Precios",
      component: Precios,      
      meta: { middleware: permissions }
    },
    {
      path: "descuentos",
      name: "Descuentos",
      component: Descuentos,
      meta: { middleware: permissions }
    },
    {
      path: "corridas",
      name: "Corridas",
      component: Corridas,
      meta: { middleware: permissions }
    },
    {
      path: "canje",
      name: "Canje",
      component: CanjeMasivo,
      meta: { middleware: permissions }
    }
  ]
};

let operacionMenu = {
  path: "/",
  component: DashboardLayout,
  name: "Operacion",
  children: [
    {
      path: "venta",
      name: "Venta",
      components: { default: Venta },
      meta: { middleware: permissions }
    },
    {
      path: "boletos",
      name: "Boletos",
      components: { default: Boletos },
      meta: { middleware: permissions }
    },
    {
      path: "arqueos",
      name: "Arqueo",
      components: { default: Arqueo },
      meta: { middleware: permissions }
    },
    {
      path: "facturacion",
      name: "Facturacion",
      components: { default: Facturacion },
      meta: { middleware: permissions }
    },
    {
      path: "facturacionglobal",
      name: "FacturacionGlobal",
      components: { default: FacturacionGlobal },
      meta: { middleware: permissions }
    },
    {
      path: "movimientos",
      name: "MovimientoCaja",
      components: { default: MovimientoCaja },
      meta: { middleware: permissions }
    },
    {
      path: "documentar",
      name: "CheckLuggage",
      components: { default: CheckLuggage },
      meta: { middleware: permissions }
    },
    {
      path: "abordaje",
      name: "Boarding",
      components: { default: Boarding },
      meta: { middleware: permissions }
    },
    {
      path: "reporte/boletos",
      name: "ReporteBoletos",
      components: { default: ReporteBoletos },
      meta: { middleware: permissions }
    },
    {
      path: "reporte/salidas",
      name: "ReporteSalidas",
      components: { default: ReporteSalidas },
      meta: { middleware: permissions }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { middleware: guest }
    },
    {
      path: "/password/reset",
      name: "PasswordReset",
      component: PasswordReset,
      meta: { middleware: guest }
    },
    {
      path: "/password/email",
      name: "PasswordEmail",
      component: PasswordEmail,
      meta: { middleware: guest }
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard"
  },
  gestionMenu, operacionMenu,
  {
    path: "/",
    component: DashboardLayout,
    name: "Dashboard layout",
    children: [
      {
        path: "perfil",
        name: "Mi Perfil",
        components: { default: UserProfile },
        meta: { middleware: auth }
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { middleware: auth }
      },
      {
        path: "alternative",
        name: "Alternative",
        component: AlternativeDashboard,
        meta: {
          navbarType: "light"
        }
      }
    ]
  },
  authPages
];

export default routes;
